import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { states } from "../../../services/states";
import { MdAddPhotoAlternate } from "react-icons/md";
import { IconButton } from "@mui/material";
import {
  Button,
  Input,
  Select,
  Spin,
  Switch,
  DatePicker,
  Tag,
  Avatar,
} from "antd";
import { InputTel, ViewInput } from "../../../GlobalStyles";
import userPhoto from "../../../images/user.png";
import dayjs from "dayjs";

export default function EditCredential() {
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(true);
  const [services, setServices] = useState("");
  const [name, setName] = useState("");
  const [profession, setProfession] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cities, setCities] = useState([]);
  const [citiesC, setCitiesC] = useState([]);
  const [phone_number, setPhone_number] = useState("");
  const [birthday, setBirthday] = useState("");
  const [city, setCity] = useState("");
  const [photo, setPhoto] = useState("");
  const [state, setState] = useState("");
  const [citiesServices, setCitiesServices] = useState("");
  const [stateC, setStateC] = useState("");
  const [description, setDescription] = useState("");

  const { id } = useParams();

  useEffect(() => {
    loadingCredential();
  }, []);

  async function loadingCredential() {
    setLoading(true);
    await api
      .get(`/credential/${id}`)
      .then((response) => {
        let credential = response.data;
        if (credential.state) {
          setCities(
            states.filter((item) => {
              return item.sigla == credential.state;
            })[0].cidades,
          );
        }
        setName(credential.name);
        setEmail(credential.email);
        setProfession(credential.profession);
        setCity(credential.city);
        setState(credential.state);
        setServices(credential.services || "");
        setDescription(credential.description);
        setVisible(credential.visible);
        if (credential.photo) {
          setPhoto({ photo_url: credential.photo_url });
        }
        setPhone_number(credential.phone_number);
        setBirthday(credential.birthday);
        setCitiesServices(credential.served_cities || "");
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function completedCredential() {
    if (
      !name ||
      !email ||
      !description ||
      !phone_number ||
      !birthday ||
      !profession ||
      !city ||
      !state ||
      !citiesServices ||
      !services
    ) {
      toast.warn(
        "Preencha todos os campos e adicione pelo menos uma cidade atendida e um serviço",
      );
    } else {
      const data = new FormData();
      data.append("name", name);
      data.append("phone_number", phone_number);
      data.append("password", password);
      data.append("email", email.toLowerCase().replace(/ /g, ""));
      data.append("description", description);
      data.append("birthday", birthday);
      data.append("profession", profession);
      data.append("city", city);
      data.append("state", state);
      data.append("visible", visible);
      data.append("served_cities", citiesServices);
      data.append("services", services);
      if (photo.name) {
        data.append("file", photo, photo.name);
      }
      await api
        .put(`/admin/credential/${id}`, data)
        .then(async (ok) => {
          toast.success("Credenciado editado com sucesso");
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response.data.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Container>
        {loading ? (
          <Spin size="large" style={{ marginTop: 50 }} />
        ) : (
          <>
            <h1>Editar Credenciado</h1>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: 30,
              }}
            >
              <div style={{ position: "relative" }}>
                <Avatar
                  size={160}
                  src={photo.photo_url ? photo.photo_url : userPhoto}
                  style={{
                    border: "4px solid #f0f0f0",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  }}
                />
                <label
                  htmlFor="avatar"
                  style={{
                    position: "absolute",
                    bottom: 5,
                    right: 5,
                    background: "#fff",
                    borderRadius: "50%",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    display: "flex",
                    width: 40,
                    height: 40,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <MdAddPhotoAlternate color="#f2760a" size={24} />
                  <input
                    id="avatar"
                    style={{ display: "none" }}
                    type="file"
                    accept="image/*"
                    onChange={(file) => {
                      let photo = file.target.files[0];
                      photo.photo_url = URL.createObjectURL(
                        file.target.files[0],
                      );
                      setPhoto(photo);
                    }}
                  />
                </label>
              </div>
            </div>

            <h2>Altere os dados do credenciado</h2>

            <ViewInput className="input">
              <p>Nome</p>
              <Input
                value={name}
                placeholder={"nome"}
                onChange={(text) => {
                  setName(text.target.value);
                }}
              />
            </ViewInput>

            <ViewInput className="input">
              <p>Nova Senha</p>
              <Input
                value={password}
                placeholder={"senha"}
                type="password"
                onChange={(text) => {
                  setPassword(text.target.value);
                }}
              />
            </ViewInput>

            <ViewInput className="input">
              <p>Profissão</p>
              <Input
                value={profession}
                placeholder={"profissão"}
                onChange={(text) => {
                  setProfession(text.target.value);
                }}
              />
            </ViewInput>

            <ViewInput className="input">
              <p>Email</p>
              <Input
                value={email}
                placeholder={"email"}
                onChange={(text) => {
                  setEmail(text.target.value);
                }}
              />
            </ViewInput>

            <ViewInput className="input">
              <p>Data de nascimento</p>
              <DatePicker
                style={{ width: "100%" }}
                format="DD/MM/YYYY"
                placeholder="Selecione a data"
                value={birthday ? dayjs(birthday) : null}
                onChange={(date, dateString) => {
                  setBirthday(date ? date.format("YYYY-MM-DD") : "");
                }}
              />
            </ViewInput>

            <ViewInput className="input">
              <p>Telefone ( Whatsapp )</p>
              <InputTel
                mask="(99) 99999-9999"
                maskChar=""
                noSpaceBetweenChars={true}
                value={phone_number}
                placeholder={"telefone ( whatsapp )"}
                onChange={(text) => {
                  setPhone_number(text.target.value.replace(/[^0-9]/g, ""));
                }}
              />
            </ViewInput>

            <ViewInput>
              <p>Descrição</p>
              <Input.TextArea
                value={description}
                placeholder={"descreva sobre o credenciado"}
                autoSize={{ minRows: 4 }}
                onChange={(text) => {
                  setDescription(text.target.value);
                }}
              />
            </ViewInput>

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <ViewInput className="input" style={{ width: "48%" }}>
                <p style={{ marginTop: 10 }}>Estado</p>
                <Select
                  value={state}
                  style={{
                    width: "100%",
                    textAlign: "left",
                  }}
                  onChange={(value) => {
                    setState(value);
                    setCities(
                      states.filter((item) => {
                        return item.sigla == value;
                      })[0].cidades,
                    );
                  }}
                >
                  <Select.Option value={""}>Selecione seu estado</Select.Option>
                  {states.map((item) => {
                    return (
                      <Select.Option key={item.sigla} value={item.sigla}>
                        {item.nome}
                      </Select.Option>
                    );
                  })}
                </Select>
              </ViewInput>

              <ViewInput className="input" style={{ width: "48%" }}>
                <p style={{ marginTop: 10 }}>Cidade</p>
                <Select
                  disabled={state == ""}
                  value={city}
                  style={{
                    width: "100%",
                    textAlign: "left",
                  }}
                  onChange={(value) => {
                    setCity(value);
                  }}
                >
                  <Select.Option value={""}>Seleciona sua cidade</Select.Option>
                  {cities.map((item) => {
                    return (
                      <Select.Option key={item} value={item}>
                        {item}
                      </Select.Option>
                    );
                  })}
                </Select>
              </ViewInput>
            </div>

            <div style={{ width: "100%", marginTop: 20 }}>
              <h2>Cidades em que você atende</h2>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <ViewInput className="input" style={{ width: "48%" }}>
                  <p style={{ marginTop: 10 }}>Estado</p>
                  <Select
                    value={stateC}
                    style={{
                      width: "100%",
                      textAlign: "left",
                    }}
                    onChange={(value) => {
                      setStateC(value);
                      setCitiesC(
                        states.filter((item) => {
                          return item.sigla == value;
                        })[0].cidades,
                      );
                    }}
                  >
                    <Select.Option value={""}>Seleciona o estado</Select.Option>
                    {states.map((item) => {
                      return (
                        <Select.Option key={item.sigla} value={item.sigla}>
                          {item.nome}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </ViewInput>

                <ViewInput className="input" style={{ width: "48%" }}>
                  <p style={{ marginTop: 10 }}>Adicione as cidades</p>
                  <Select
                    disabled={stateC == ""}
                    value={""}
                    style={{
                      width: "100%",
                      textAlign: "left",
                    }}
                    onChange={(value) => {
                      if (value) {
                        let result = citiesServices + value + ` - ${stateC};`;
                        setCitiesServices(result);
                      }
                    }}
                  >
                    <Select.Option value={""}>
                      Adiciona uma cidade
                    </Select.Option>
                    {citiesC.map((item) => {
                      if (
                        citiesServices.indexOf(item + ` - ${stateC};`) == -1
                      ) {
                        return (
                          <Select.Option key={item} value={item}>
                            {item}
                          </Select.Option>
                        );
                      }
                      return null;
                    })}
                  </Select>
                </ViewInput>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexWrap: "wrap",
                  justifyContent: "flex-start",
                  marginTop: 10,
                  gap: "8px",
                }}
              >
                {citiesServices.split(";").map((item) => {
                  if (item) {
                    return (
                      <Tag
                        key={item}
                        closable
                        onClose={() => {
                          let citiesServicesC = citiesServices.replace(
                            item + ";",
                            "",
                          );
                          setCitiesServices(citiesServicesC);
                        }}
                        style={{ fontSize: 14, padding: "4px 10px" }}
                      >
                        {item}
                      </Tag>
                    );
                  }
                  return null;
                })}
              </div>
            </div>

            <div style={{ width: "100%", marginTop: 20 }}>
              <h2>Selecione seus serviços</h2>
              <ViewInput className="input">
                <p style={{ marginTop: 10 }}>Serviços</p>
                <Select
                  value={""}
                  style={{
                    width: "100%",
                    textAlign: "left",
                  }}
                  onChange={(value) => {
                    if (value) {
                      let result = services + value + ";";
                      setServices(result);
                    }
                  }}
                >
                  <Select.Option value={""}>
                    Adicione seus serviços
                  </Select.Option>
                  {services.indexOf("Treinamentos") == -1 && (
                    <Select.Option value={"Treinamentos"}>
                      Treinamentos
                    </Select.Option>
                  )}
                  {services.indexOf("Visita Técnica") == -1 && (
                    <Select.Option value={"Visita Técnica"}>
                      Visita Técnica
                    </Select.Option>
                  )}
                  {services.indexOf("Medições ambientais") == -1 && (
                    <Select.Option value={"Medições ambientais"}>
                      Medições ambientais
                    </Select.Option>
                  )}
                  {services.indexOf("Elaboração de PGR, PCMSO LTCAT") == -1 && (
                    <Select.Option value={"Elaboração de PGR, PCMSO LTCAT"}>
                      Elaboração de PGR, PCMSO LTCAT
                    </Select.Option>
                  )}
                </Select>
              </ViewInput>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexWrap: "wrap",
                  justifyContent: "flex-start",
                  marginTop: 10,
                  gap: "8px",
                }}
              >
                {services.split(";").map((item) => {
                  if (item) {
                    return (
                      <Tag
                        key={item}
                        closable
                        onClose={() => {
                          let servicesC = services.replace(item + ";", "");
                          setServices(servicesC);
                        }}
                        style={{ fontSize: 14, padding: "4px 10px" }}
                      >
                        {item}
                      </Tag>
                    );
                  }
                  return null;
                })}
              </div>
            </div>

            <ViewInput
              style={{
                justifyContent: "flex-start",
                width: 200,
                display: "flex",
                flexDirection: "column",
                marginTop: 20,
              }}
            >
              <p>Visibilidade (Aparecer no site)</p>
              <Switch
                checked={visible}
                style={{
                  width: 30,
                }}
                onChange={(value) => {
                  setVisible(value);
                }}
              />
            </ViewInput>

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                margin: "35px 0",
              }}
            >
              <Button
                type="primary"
                style={{
                  height: 45,
                  fontSize: 18,
                  width: "100%",
                  maxWidth: 390,
                }}
                onClick={() => {
                  completedCredential();
                }}
              >
                Salvar
              </Button>
            </div>
          </>
        )}
      </Container>
    </div>
  );
}
